export default
function calculateBlocksByLine(breaks, paramLines, removeBreaks){
  let blocks = [];

  //Remove stanza breaks if option true
  let lines = removeBreaks ? paramLines.filter((line) => line !== "") : paramLines;

  //Set up correct num of empty arrays
  for(let i=1; i <= breaks.length + 1; i++){
    blocks.push([]);
  }

  //Clone breaks to avoid mutation
  let clonedBreaks = breaks.slice(),
      blockNum = 0,
      lineBreaks = 0;

  lines.forEach((line, i) => {
    //For line breaks (empty strings)
    if(line.length < 1)
      lineBreaks++;

    //if line num less than break, push
    if(i - lineBreaks < clonedBreaks[0]){
      blocks[blockNum].push(line);
    } else if(clonedBreaks[0]){
      //Else move to next and shift the array
      blockNum++;
      blocks[blockNum].push(line);
      clonedBreaks.shift();
    } else{
      blocks[blockNum].push(line);
    }
  });

  return blocks;
}



// WEBPACK FOOTER //
// ./src/helpers/calculateBlocksByLine.js